import {
  ColumnFiltersState,
  getCoreRowModel,
  getFilteredRowModel,
  getSortedRowModel,
} from "@tanstack/react-table";
import { Dispatch, SetStateAction, useMemo, useState } from "react";

import { SortData } from "#modules/quoteRequestLines/fetchQuoteRequestLines.api";
import { makeQuoteRequestLinesListData } from "#modules/quoteRequestLines/makeQuoteRequestLinesListData";
import { QuoteResquestLineWithBatchInfo } from "#modules/quoteRequestLines/QuoteRequestLines.page";
import { QuoteRequestLinesTableView } from "#modules/quoteRequestLines/QuoteRequestLinesTableView";
import { useQuoteRequestLinesTableColumns } from "#modules/quoteRequestLines/useQuoteRequestLinesTableColumns";
import { useReactTableNoMemo } from "#shared/helpers/useReactTableNoMemo";
import { Loader } from "#shared/view/components/Loader";
import { Pagination } from "#shared/view/components/Pagination/Pagination";

type Props = {
  quoteRequestLinesWithBatchInfo: QuoteResquestLineWithBatchInfo[];
  quoteRequestLinesCount: number;
  quoteRequestLinesItemsCountPerPage: number;
  isDataLoading: boolean;
  sort: SortData;
  setSort: Dispatch<SetStateAction<SortData>>;
};

export const QuoteRequestLinesList = ({
  quoteRequestLinesWithBatchInfo,
  quoteRequestLinesCount,
  quoteRequestLinesItemsCountPerPage,
  isDataLoading,
  sort,
  setSort,
}: Props) => {
  const [columnFilters, setColumnFilters] = useState<ColumnFiltersState>([]);

  const quoteRequestLinesListData = useMemo(
    () => makeQuoteRequestLinesListData(quoteRequestLinesWithBatchInfo),
    [quoteRequestLinesWithBatchInfo],
  );

  const quoteRequestsLinesColumns = useQuoteRequestLinesTableColumns();

  const { rows, headerGroups } = useReactTableNoMemo({
    data: quoteRequestLinesListData,
    columns: quoteRequestsLinesColumns,
    onColumnFiltersChange: setColumnFilters,
    getCoreRowModel: getCoreRowModel(),
    getFilteredRowModel: getFilteredRowModel(),
    getSortedRowModel: getSortedRowModel(),
  });

  if (isDataLoading) {
    return <Loader />;
  }

  return (
    <>
      <QuoteRequestLinesTableView
        rows={rows}
        headerGroups={headerGroups}
        columnFilters={columnFilters}
        sort={sort}
        setSort={setSort}
      />

      <Pagination
        totalItemsCount={quoteRequestLinesCount}
        itemsPerPage={quoteRequestLinesItemsCountPerPage}
      />
    </>
  );
};
